import { PasscodeScreen } from '@/modules/passcode';
import { useLocalSearchParams } from 'expo-router';
import React from 'react';

export default function Passcode() {
    const params = useLocalSearchParams<{ mode?: 'setup' | 'change' | 'verify'; from?: string }>();
    const hideHeaderLogo = params.from === 'privacy';
    return (
        <PasscodeScreen
            mode={params.mode || 'setup'}
            hideHeaderLogo={!!hideHeaderLogo}
            {...(params.from ? { from: params.from } : {})}
        />
    );
}